import styled, { keyframes } from "styled-components";
import QRCodeReact from "qrcode.react";

import { ReactComponent as SearchSvg } from "../assets/svg/search.svg";
import { ReactComponent as DropdownArrow } from "../assets/svg/dropdown-arrow.svg";

export const Frame = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  max-width: 100%;
  height: 100%;
  margin: 0 auto;
  background-color; ${(props) => props.theme.tenthColor};
`;

//Header
export const Header = styled.header`
  height: 8vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100%;
    max-width: 1200px;

    @media (max-width: 1366px) {
      max-width: 1024px;
    }
    @media (max-width: 1124px) {
      max-width: none;
      padding: 0 50px;
    }
  }
`;

export const HeaderWrapperLeft = styled.div`
  height: 40%;

  &:hover {
    cursor: pointer;
  }
`;

export const HeaderWrapperRight = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 60%;

  @media (max-width: 1366px) {
    width: 73%;
  }

  div:first-child {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 46%;
    margin-right: 4%;
    font-size: 0.8rem;
  }
  div:first-child p {
    margin: 0;
    color: ${(props) => props.theme.seventhColor};
    font-weight: bold;

    &:hover {
      cursor: pointer;
    }
  }

  div:last-child {
    display: flex;
    align-items: center;
  }
  div:last-child button {
    padding: 0.5rem 2rem;
    margin-left: 2rem;
  }
`;

export const HeaderOption = styled.span`
  display: flex;
  align-items: center;
`;

//Main
export const MainWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: 78vh;
`;

//Footer
export const Footer = styled.footer`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 14vh;
  width: 100%;
  background-color: ${(props) => props.theme.firstColor};
`;
export const FooterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  width: 100%;
  max-width: 1200px;
  padding: 1.2% 0 1% 0;

  @media (max-width: 1366px) {
    max-width: 1024px;
  }
  @media (max-width: 1124px) {
    max-width: none;
    padding: 1.2% 50px 1% 50px;
  }
`;
export const FooterWrapperFirst = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 30%;

  div:nth-of-type(1) {
    display: flex;
    align-items: center;
    height: 100%;

    img {
      height: 24px;
      width: auto;
      margin-right: 1.5rem;
    }
  }
  div:nth-of-type(2) {
    button {
      padding: 0.3rem 1rem;
      font-weight: bold;
    }
    button:nth-of-type(1) {
      border: 2px solid ${(props) => props.theme.tenthColor};
      color: ${(props) => props.theme.tenthColor};
      background-color: ${(props) => props.theme.firstColor};
      margin-right: 1rem;
    }
    button:nth-of-type(2) {
      background-color: ${(props) => props.theme.tenthColor};
      color: ${(props) => props.theme.firstColor};
      border: 2px solid ${(props) => props.theme.tenthColor};

      a {
        text-decoration: none;
        color: ${(props) => props.theme.firstColor};
      }
    }
  }
`;
export const FooterWrapperSecond = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40%;
  width: 100%;

  a {
    text-decoration: none;
    color: ${(props) => props.theme.tenthColor};
    margin: 0;
    font-size: 0.8rem;
    font-weight: bold;
  }
`;
export const FooterWrapperThird = styled.div`
  height: 10%;
  text-align: center;
  font-size: 0.7rem;
  color: ${(props) => props.theme.tenthColor};

  p {
    margin: 0;
  }
`;

//Common Styles
export const ButtonDark = styled.button`
  padding: 0.5rem 4rem;
  background-color: ${(props) => props.theme.secondColor};
  border: 1px solid ${(props) => props.theme.secondColor};
  font-weight: bold;
  color: ${(props) => props.theme.tenthColor};

  &:disabled {
    border: 1px solid #d9d9d9;
    background-color: #d9d9d9;
    color: ${(props) => props.theme.eighthColor};
  }

  @media (max-width: 1366px) {
    max-width: 1024px;
  }
`;
export const ButtonLight = styled.button`
  padding: 0.5rem 4rem;
  background-color: ${(props) => props.theme.tenthColor};
  border: 1px solid ${(props) => props.theme.secondColor};
  font-weight: bold;
  color: ${(props) => props.theme.secondColor};

  &:disabled {
    border: 1px solid #d9d9d9;
    background-color: #d9d9d9;
    color: ${(props) => props.theme.eighthColor};
  }
`;

export const ContainerFlexLeft = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  max-width: 1200px;

  @media (max-width: 1366px) {
    max-width: 1024px;
  }
  @media (max-width: 1124px) {
    max-width: none;
    padding-right: 50px;
    padding-left: 50px;
  }

  > h2  {
    font-weight: bold;
    color: ${(props) => props.theme.firstColor};
  }
`;

export const InputWrapper = styled.span`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 20px;

  label {
    font-size: 0.8rem;
    font-weight: bold;
    color: ${(props) => props.theme.firstColor};
    margin-bottom: 5px;
  }
  input {
    width: 100%;
    padding: 0.5rem;
    border-radius: 2px;
    border: 1px solid ${(props) => props.theme.ninthColor};
    box-shadow: none;

    &:focus {
      border: 1px solid ${(props) => props.theme.fourthColor};
      outline: 1px solid ${(props) => props.theme.fourthColor};
    }
  }
  p {
    font-size: 0.7rem;
    margin: 0;
    color: ${(props) => props.theme.eighthColor};
  }
`;

export const RedAsterisk = styled.b`
  color: ${(props) => props.theme.fourthColor};
`;

// QR Code and Animations
export const QRCode = styled(QRCodeReact)`
  width: 70%;
  height: 70%;
`;

export const QRCodeContainer = styled.div`
  width: 30%;
  aspect-ratio: 1;
  margin-top: 2rem;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
  background-color: ${(props) => props.theme.tenthColor};
  border-radius: 7px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const rotate = keyframes`
  0% {
      transform: rotate(0deg);
  }
  100% {
      transform: rotate(360deg);
  }
`;
export const LoadingSpinner = styled.span`
  width: 100%;
  aspect-ratio: 1 / 1;
  border: 10px solid ${(props) => props.theme.secondColor};
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: ${rotate} 1s linear infinite;
`;
export const LoadingSpinnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.theme.secondColor};

  p {
    margin-top: 1rem;
    font-weight: bold;
  }
`;

export const ErrorsContainer = styled(ContainerFlexLeft)`
  padding-top: 8vh;
  padding-bottom: 12vh;
  
  && > h2  {
    font-weight: bold;
    color: ${(props) => props.theme.firstColor};
  }

  > p {
    font-size: 0.8rem;
    margin-bottom: 0.5rem;
    color: black;

    u {
      color: ${(props) => props.theme.secondColor};
      font-weight: bold;
      &:hover {
        cursor: pointer;
      }
    }
  }
`;

// Icons
export const DropdownArrowIcon = styled(DropdownArrow)`
  width: 0.7em;
  height: 0.7em;
  margin-right: 5px;
  color: ${(props) => props.theme.seventhColor};
`;
export const SearchIcon = styled(SearchSvg)`
  width: 1em;
  height: 1em;
  margin-right: 5px;
  color: ${(props) => props.theme.seventhColor};
`;

export const Logo = styled.img`
  height: 100%;
`;
